export class GenPersonEntity{
    id:number;
    identification:string;
    firstName:string;
    lastName:string;
    userName:string;
    password:string;
    mail:string;
    creationDate:string;
    loginDate:string;
    centerCostId:number;
    centerCost:string;
    positionId:number;
    position:string;
    countryId:number;
    departmentId:number;
    cityId:number;
    city:string;
    active:boolean;
    countryGeneralId:string;

    constructor(){}
}
